export const getAdminJwt = () => localStorage.getItem('adminJwt');
export const setAdminJwt = (val) => localStorage.setItem('adminJwt', val);
export const getJwt = () => localStorage.getItem('jwt');
export const saveAdminJwt = () => setAdminJwt(getJwt());
export const setJwt = (jwt) => localStorage.setItem('jwt', jwt);
// eslint-disable-next-line consistent-return
export const logout = (addRef) => {
    const { pathname, search } = window.location;
    const adminJwt = getAdminJwt();

    if (adminJwt) {
        setJwt(adminJwt);
        setAdminJwt('');

        return window.location.assign('/admin/users');
    }

    setJwt('');

    if (pathname !== '/login') {
        const ref = pathname.length > 1 && addRef
            ? `?ref=${pathname}${search.replace('?', '#')}`
            : '';

        return window.location.assign(`/login${ref}`);
    }
};
